<template>
  <div class="custom-card">
    <div class="card-content">
      <span class="paragraph-20-weight300">{{ text }}</span>
      <span class="fontSize20 card-value">{{ value | formatNumberZero }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardValue",
  props: ["text", "value"],
};
</script>

<style scoped>
.custom-card {
  border-radius: 0.25rem;
  padding: 1rem 1.25rem;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  margin-bottom: 1rem;
  background-color: #fff;
  transition: transform 0.2s, box-shadow 0.2s;
  height: calc(100% - 1rem); /* Ajusta a altura para combinar com CardUsage */
  border: 1px solid #e0e0e0;
}

.custom-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
}

.card-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 2.5rem; /* Altura mínima para corresponder ao CardUsage com a barra de progresso */
}

.card-value {
  font-weight: 600;
  color: #007bff; /* Cor para destacar valores similar ao CardUsage */
}
</style>


